import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import * as userActions from 'redux/modules/users';
import * as ficheActions from 'redux/modules/fiches';
import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
import { isLoaded as areUsersLoaded, load as loadUsers } from 'redux/modules/users';

import { initializeWithKey } from 'redux-form';
import { UserForm } from 'components';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';

var _ = require('underscore');

import { DeleteButton } from 'components';

import { LinkContainer } from 'react-router-bootstrap';
import { routeActions } from 'react-router-redux';

import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { ErrorAlert } from 'components'
import { MobileCardList, MobileCard } from '../../components/common/MobileCard';

import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
	promise: ({ store: { dispatch, getState }, params }) => {
		const promises = [];

		promises.push(dispatch(loadGroups(params)));
		promises.push(dispatch(loadUsers(params)));
		promises.push(dispatch(ficheActions.load(0, params)));

		return Promise.all(promises);
	}
}])

@connect(
	state => ({
		users: state.users.data,
		editing: state.users.editing,
		is_editing: state.users.is_editing,
		error: state.users.error,
		loading: state.users.loading,
		groups: state.groups.data,
		user: state.auth.user,
		loadingSendCredentials: state.users.loadingSendCredentials,
		sendCredentialsSuccess: state.users.sendCredentialsSuccess,
		sendCredentialsError: state.users.sendCredentialsError,
		fiches: state.fiches.data
	}),
	{ ...userActions, initializeWithKey, pushState: routeActions.push, go: routeActions.go })

export default class Users extends Component {

	render() {

		var self = this;

		const {t} = this.props

	
		const tooltip = (
			<Tooltip id="tooltip"><strong>{t("users.send_credentials")}</strong></Tooltip>
		);

		const tooltipSup = (
			<Tooltip id="tooltip"><strong>{t("main.supervision")}</strong></Tooltip>
		);


		const handleEdit = (user) => {
			const { editStart } = this.props; // eslint-disable-line no-shadow
			return () => editStart(String(user.id));
		};

		const handleDelete = (id) => {
			const { deleteUser } = this.props; // eslint-disable-line no-shadow
			return () => deleteUser(id, this.props.params);
		};

		const handleLoad = () => {
			const { load } = this.props; // eslint-disable-line no-shadow
			load(this.props.params);
		};

		var { users, error, editing, loading, load, save, groups } = this.props;

		let refreshClassName = 'fa fa-refresh';
		if (loading) {
			refreshClassName += ' fa-spin';
		}
		const styles = require('./Users.scss');

		var content = [];
		var edit_id = false;

		for (var id in editing) {
			if (editing[id] == true) {
				edit_id = id;
			}
		}

		if (editing[edit_id] == true) {
			//Afuserr seulement le formulaire de la ligne éditée
			var user = _.where(users, { id: parseInt(edit_id) })[0];
			var groupList = user.groups.map((g) => {
				return g.id;
			});

			var emails = []

			if (user.mails) {
				emails = user.mails.split('%').map((m) => {
					var obj = m.split(':')
					var flags = {
						panne_flag_debut: obj[1] == '1' || obj[1] == '3' ? true : false,
						panne_flag_fin: obj[1] == '2' || obj[1] == '3' ? true : false,
						panne_tempo: obj[2],
						dispo_flag_debut: obj[3] == '1' || obj[3] == '3' ? true : false,
						dispo_flag_fin: obj[3] == '2' || obj[3] == '3' ? true : false,
						dispo_tempo: obj[4],
						usager_flag_debut: obj[5] == '1' || obj[5] == '3' ? true : false,
						usager_flag_fin: obj[5] == '2' || obj[5] == '3' ? true : false,
						usager_tempo: obj[6],
						cyclique_tempo: obj[7] == '0' ? false : true,
						maintenance_tempo: obj[8],
						id: obj[9]
					}
					return {
						address: obj[0],
						...flags
					};
				});
			}
			user.super_user = user.super_user == 1 ? true : false
			content.push(
				<UserForm formKey={String(user.id)} user_emails={emails} user_info={this.props.user} user_data={user}
					userId={String(user.id)} key={String(user.id)}
					initialValues={{ user: user, group: { groupList }, mail: emails }}
					urlParams={this.props.params} userGroups={groupList} fiches={this.props.fiches} />
			);
		} else {
			if (this.props.user.role != 'admin') {
				users = users.filter((u) => u.supervisor != 1)
			}

			var mobileCards = [];
			var rows = _.map(users, (user) => {
				var emails = []
				if (user.mails) {
					emails = user.mails.split('%').map((m) => {
						var obj = m.split(':')
						return { address: obj[0], contact_alert: obj[1] == '1' ? true : false };
					});
				}

				var groups = user.groups.map((g) => {
					return g.name;
				}).join(', ');

				if (groups.length > 30) {
					groups = groups.substring(0, 30) + '...';
				}

				var supPath;

				if (this.props.user.role == 'admin') {
					supPath = "/admin/supervision/" + this.props.params['id'] + "/" + user.id + "/"
				} else if (this.props.user.role.indexOf('client') > -1 || this.props.user.role == 'demo') {
					supPath = "/client/supervision/" + user.id + "/"
				} else if (this.props.user.role.indexOf('user') > -1 && this.props.user.super_user == 1) {
					supPath = "/superuser/supervision2/" + user.id + "/"
				}

				var sendIcon = !this.props.loadingSendCredentials ? <i className='fa fa-mail-reply' /> : <i className="fa fa-spinner fa-pulse fa-fw"></i>
				var trStyle = {}

				if (user.supervisor == 1) {
					trStyle['background'] = '#ffdbdb'
				}

				const sendCredentials = () => {
					self.props.dispatch(
						userActions.sendCredentials(
							{ user, mail: emails.map((m) => m.address) }, self.props.params
						)
					)
				}

				const deleteBtn = (
					<DeleteButton
						disabled={this.props.user.role.indexOf('user') > -1 && ((String(user.id) == String(this.props.user.id)) || user.super_user == 1) && this.props.user.supervisor == 0} 
						size={"sm"} ctext={t("main.confirm")} 
						callback={handleDelete(user.id)} 
					/>
				)

				mobileCards.push(
					<MobileCard
						key={user.id}
						className={user.supervisor == 1 ? 'mobile-card-red' : ''}
						onClick={handleEdit(user)}
						title={[user.prenom, user.nom].filter(Boolean).join(' ') || user.login}
						subtitle={user.login + (user.supervisor == 1 ? '-sup' : '-usr')}
						fields={[
							{ label: t("main.society"), value: user.societe },
							{ label: t("main.groups"), value: groups },
						]}
						actions={[
							<Button key="sup" bsStyle="primary" bsSize="sm" onClick={() => { this.props.pushState(supPath) }}>
								<i className="fa fa-eye" /> {t("main.supervision")}
							</Button>,
							<Button key="send" bsStyle="warning" bsSize="sm" onClick={sendCredentials}>
								{sendIcon} {t("users.send_credentials")}
							</Button>,
							<span key="del">{deleteBtn}</span>
						]}
					/>
				)

				return (

					<tr key={user.id} style={trStyle}>
						<td>{user.nom}</td>
						<td>{user.prenom}</td>
						<td>{user.login}{user.supervisor == 1 ? '-sup' : '-usr'}</td>
						<td>{user.societe}</td>
						<td>{groups}</td>


						<td className={styles.buttonCol} style={{ position: 'relative', width: '145px' }}>
							<button className="btn btn-primary btn-sm" onClick={handleEdit(user)}>
								<i className="fa fa-pencil" />
							</button>

							&nbsp;
	            			<OverlayTrigger placement="top" overlay={tooltip}>
								<button className={"btn btn-warning btn-sm"}
									onClick={sendCredentials}>
									{sendIcon}
								</button>
							</OverlayTrigger>

							&nbsp;
	            			{deleteBtn}
						</td>

						<td style={{ position: 'relative', width: '100px' }}>
							<OverlayTrigger placement="top" overlay={tooltipSup}>
								<button onClick={() => { this.props.pushState(supPath) }} className="btn btn-primary">
									<i className="fa fa-eye" />
								</button>
							</OverlayTrigger>
						</td>
					</tr>
				)
			})


			content.push(<MobileCardList>{mobileCards}</MobileCardList>);

			content.push(
				<div className="table-responsive hidden-xs">
					{users && _.size(users) > 0 &&
						<table className="table table-striped">
							<thead>
								<tr>
									<th>{t("main.lastname")}</th>
									<th>{t("main.firstname")}</th>
									<th>Login</th>
									<th>{t("main.society")}</th>
									<th>{t("main.groups")}</th>
									<th>{t("main.actions")}</th>
									<th>{t("main.consultation")}</th>
								</tr>
							</thead>
							<tbody>
								{rows}
							</tbody>
						</table>}
				</div>
			);

		}

		var cid = this.props.params.id

		var addUrl;

		if (this.props.user.role == 'admin') {
			addUrl = '/admin/users/' + cid + '/create';
		} else if (this.props.user.role.indexOf('client') > -1 || this.props.user.role == 'demo') {
			addUrl = '/client/adduser';
		} else if (this.props.user.role.indexOf('user') > -1) {
			addUrl = '/superuser/adduser';
		}

		return (
			<div className={styles.users + ' container'}>

				{edit_id == false ?
					<div>
						<h1>{t("users.users")}&nbsp;
			         		 <button className={styles.refreshBtn + ' btn btn-success'} onClick={handleLoad}>
								<i className={refreshClassName} />
							</button>
							&nbsp;
			          		<LinkContainer to={addUrl}>
								<button className={styles.refreshBtn + ' btn btn-primary'}>
									<i className='fa fa-user-plus' /> {t("users.create_user")}
				          		</button>
							</LinkContainer>
						</h1>
					</div> : <h1>{t("users.edit_user")}</h1>
				}

				<Helmet title={t("users.users")} />
				{error &&
					<ErrorAlert errorMessage={error} buttonText={t("dashboardView.reload_page")} callback={() => this.props.load(this.props.params)} />
				}
				{content}

			</div>


		);
	}
}

